// extracted by mini-css-extract-plugin
export default {"smsContainer":"smsCode_smsContainer__7Pt0n","smsIconContainer":"smsCode_smsIconContainer__WXv3Q","smsDescription":"smsCode_smsDescription__AK690"};